import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { MicroenterpriseAdminService } from '../services/microenterprise-admin.service';
import { RecurringBookingResult } from '../interfaces/vendor';

@Component({
  selector: 'app-bookings-recurring',
  templateUrl: './bookings-recurring.component.html',
  styleUrls: ['./bookings-recurring.component.scss']
})
export class BookingsRecurringComponent implements OnInit {
  loading = true;
  bookings: RecurringBookingResult[] = [];
  errorMessage = '';
  recurringId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private service: MicroenterpriseAdminService,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    // prevent search-engine indexing
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    this.recurringId = this.route.snapshot.paramMap.get('recurringBookingId');
    if (!this.recurringId) {
       this.errorMessage = 'No recurring booking ID provided.';
       this.loading = false;
       return;
     }

    this.service.searchRecurringBookings(this.recurringId).subscribe(
       results => {
         this.bookings = results;
         this.loading = false;
       },
       () => {
         this.errorMessage = 'Error loading bookings. Please try again later.';
         this.loading = false;
       }
     );
  }
}
